"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pin = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Pin = function (_a) {
    var id = _a.id;
    var clipPathId = id ? "Pin__clip0__".concat(id) : 'Pin__clip0';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { clipPath: "url(#".concat(clipPathId, ")") },
            react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21.165 8.925l1.912-.68a1.337 1.337 0 00.491-2.253L17.99.392a1.325 1.325 0 00-2.19.493l-.678 1.92a2.664 2.664 0 01-1.036 1.334l-4.25 2.84a3.973 3.973 0 01-2.244.693h-1.98a1.325 1.325 0 00-.942.387l-.545.6a1.337 1.337 0 000 1.88l9.377 9.426a1.324 1.324 0 001.872 0l.558-.546c.248-.252.387-.593.385-.947v-1.987c0-.804.24-1.589.69-2.253l2.83-4.267a2.658 2.658 0 011.328-1.04zM1.056 20.645a4 4 0 01.89-1.333l3.878-3.894 2.683 2.8-3.865 3.88c-.378.385-.83.69-1.328.894l-2.404.96a.662.662 0 01-.717-.147.669.669 0 01-.146-.72l1.01-2.44z", clipRule: "evenodd" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: clipPathId },
                react_1.default.createElement("path", { fill: "#fff", d: "M0 0H24V24H0z" })))));
};
exports.Pin = Pin;
//# sourceMappingURL=pin.js.map